/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_No_CarrierInputs */

const en_samples_no_carrier = /** @type {(inputs: Samples_No_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Carrier`)
};

const es_samples_no_carrier = /** @type {(inputs: Samples_No_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin transportista`)
};

/**
* | output |
* | --- |
* | "No Carrier" |
*
* @param {Samples_No_CarrierInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_no_carrier = /** @type {((inputs?: Samples_No_CarrierInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_No_CarrierInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_no_carrier(inputs)
	return es_samples_no_carrier(inputs)
});